import React from 'react';

import FooterColumn from './FooterColumn';

const ABOUT_URL = 'https://about.sparefoot.com';
const links = [
	{ href: `${ABOUT_URL}`, text: 'About' },
	{ href: `${ABOUT_URL}/jobs`, text: 'Jobs' },
	{ href: 'https://www.sparefoot.com/blog/', text: 'Blog' },
	{ href: '/storage-101.html', text: 'Storage near me' },
	{
		href: '/legal/consumer.html',
		text: 'Consumer Terms of Service and Privacy Policy',
		rel: 'nofollow',
	},
	{
		href: '/legal/client.html',
		text: 'Operator Terms of Service',
		rel: 'nofollow',
	},
	{ href: '/legal/privacy.html', text: 'Privacy policy' },
];

export function AboutSpareFoot(props) {
	return (
		<FooterColumn
			{...props}
			links={links}
			title="About SpareFoot"
		/>
	);
}

export default AboutSpareFoot;
